module.exports = __webpack_public_path__ + "static/img/hair_15.9edf766.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/hair/thumbnail/hair_15.png
// module id = Zxjh
// module chunks = 0